import React from 'react';
import { TreeView, SearchEditorOptions } from 'devextreme-react/tree-view';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { Row, Col, Label } from "reactstrap";
import Scrollspy from "react-scrollspy-ez";
import Toolbar from '@material-ui/core/Toolbar';
const $ = require("jquery");
const header = require("../../Assets/imgs/header.png");

export function ArrayToTree(arr) {
    let tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;
    var EmptyGuid = '00000000-0000-0000-0000-000000000000';
    for (let i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.Id] = mapItem(arrElem);
        if (i === 0)
            mappedArr[arrElem.Id].isExpanded = true;
        mappedArr[arrElem.Id].key = arrElem.Id;
        mappedArr[arrElem.Id].items = [];
    }
    for (var Id in mappedArr) {
        if (mappedArr.hasOwnProperty(Id)) {
            mappedElem = mappedArr[Id];
            mappedElem.key = Id;
            if (mappedElem.ParentId !== EmptyGuid) {
                mappedArr[mappedElem.ParentId].items.push(mappedElem);
            }
            else {
                tree.push(mappedElem);
            }
            delete mappedElem.ParentId;
        }
    }
    return tree;

}
export function mapItem({ Id, Title, ...others }) {
    return {
        id: Id,
        text: Title,
        ...others
    }
}

class ManualComp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idsArray: []
        };
        this.selectItem = this.selectItem.bind(this);
    }
    componentDidMount = () => {
        $(document).ready(function () {
            $("div").scroll(function () {
                $(".RowHeader").slideUp(500);
            });
            $("div.sticky-anchor2").mousemove(function () {
                $(".RowHeader").slideUp(500);
            });
        });
    }

    render() {
        return (
            <div>
                <Row className="mt70 RowHeader" hidden >
                    <Col md={6} xs={12} className="align-self-center">
                        <h1 className="MainTitle text-uppercase" >YOONIT {this.props.MainTitle} </h1>
                        <h3 className="SubTitle" > {this.props.SubTitle} </h3>
                        <Col md={3} className="RemovePadding">
                            <hr className="hrBlue" />
                        </Col>
                    </Col>
                    <Col md={6} xs={12}>
                        <img src={header} alt="" className="HeaderImg" />
                    </Col>
                </Row>
                <div id="sticky-anchor"></div>
                <Toolbar id="back-to-top-anchor" />
                <div className="sticky-anchor2" id="back-to-top-anchor">
                    <Row
                        onScroll={this.onScroll}>
                        <Col md={3} className="pr-0">
                            <div className="form mt-3" id="simple-treeview">
                                <h2 className="MainTitle mb-3" > {this.props.MainTitle} </h2>
                                <TreeView id="simple-treeview"
                                    items={this.props.data}
                                    onItemClick={this.props.clickItem}
                                    keyExpr="id"
                                    displayExpr="text"
                                    parentIdExpr="parent"
                                    searchEnabled={true}
                                    width={300}
                                    expandedExpr="isExpanded"
                                    selectionMode="single"
                                    selectByClick={true}
                                >
                                    <SearchEditorOptions
                                        placeholder={this.props.filterInput}
                                        width={300}
                                    />
                                </TreeView>
                            </div>
                        </Col>
                        <Col md={7} className="pt-3 pl-0">
                            {this.props.Paragraphs.map((item, index) => {
                                return (
                                    <div className="scrollContent" data-spy="scroll" data-target="#spy" key={index}>
                                        <div className="titleManual" id={'section' + index}>{item.Title}</div>
                                        <div className="paragraphsManual">
                                            <div
                                                className="font-16 paragraphsManual2"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.Content
                                                }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </Col>
                        <Col md={2} className="paddingContent pl-0">
                            <div id="spy">
                                {this.props.Paragraphs.length !== 0 &&
                                    <>

                                        <hr />
                                        <Label className="TableOfContent">{this.props.tableTitle}</Label>
                                    </>
                                }
                                <Scrollspy
                                    ids={this.props.idsArray}
                                    itemContainerClassName="scrollSpyContainer"
                                    activeItemClassName="active"
                                    itemClassName="spyItemClass"
                                    offset={40}
                                    includeParentClasses={true}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div >
        );
    }

    selectItem(e) {
        this.setState({
            currentItem: Object.assign({}, e.itemData)
        });
    }
}

export default ManualComp;
